export enum LivePollSessionType {
  PRESENTER_SESSION,
  PERMANENT_ROOM_SESSION,
}
